import { Component, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from '@shared/services/toastr.service';
import { ConfirmService } from '@shared/services/confirm.service';
import { AdminClusterService } from '@shared/services/admin-cluster.service';
import { concatMap, count, from, mergeMap } from 'rxjs';
import { BrainParametersService, ParamsGroup } from '@shared/services/brain-parameters.service';
import { BrainParametersComponent } from '@shared/components/brain-parameters/brain-parameters.component';

@Component({
  selector: 'app-ia-recommended-parameters',
  templateUrl: './ai-recommended-parameters.component.html',
  styleUrls: ['./ai-recommended-parameters.component.scss'],
  imports: [BrainParametersComponent],
})
export class AiRecommendedParametersComponent implements OnInit {
  paramGroups: ParamsGroup[];

  constructor(
    private adminClusterService: AdminClusterService,
    private brainParametersService: BrainParametersService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private confirmService: ConfirmService,
  ) {}

  ngOnInit() {
    this.brainParametersService.getBrainParametersAndGroups('admin').subscribe((groups) => (this.paramGroups = groups));
  }

  confirmRestoreRecommendedAllClusters() {
    this.confirmService.confirm({ html: this.translate.instant('RestoreRecommendedAllClustersAlert') }, () => {
      this.adminClusterService
        .getAll()
        .pipe(
          mergeMap((clusters) => from(clusters)),
          concatMap((cluster) => this.syncBrainParameters(cluster.uid)),
          count(),
        )
        .subscribe((n) => {
          this.toastr.success(`${n} clusters synchronisés`);
        });
    });
  }

  syncBrainParameters(clusterUid: string) {
    return this.adminClusterService.provisionBrainParameters(clusterUid);
  }
}
